import React from 'react';
import { Box } from '@mui/material';
import Header from './Header';
import Footer from './Footer';

const Layout = ({ children }) => {
  return (
    <Box 
      sx={{
        minHeight: '100vh',
        bgcolor: 'var(--bg-primary)',
        color: 'var(--text-primary)',
        transition: 'background-color var(--transition-normal), color var(--transition-normal)'
      }}
    >
      <Header />
      <Box component="main">
        {children}
      </Box>
      <Footer />
    </Box>
  );
};

export default Layout;
